<template>
  <div>
    <b-card>
      <b-card-title>
        Sys Admin
      </b-card-title>
      <b-card-body>
        <br /><br />
        <a href="/#/admin/notificationManagement"
          ><i class="fa-solid fa-file pr-3"></i>Notification Management</a
        >
        <br /><br />
        <a href="/#/admin/systems"
          ><i class="fa-solid fa-file pr-3"></i>System Management</a
        >
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
